/** Home of the public website. The Framer clone lived at /site until it became the main site. */
export const CMS_PUBLIC_PATH = "/";

/** The original Framer site, proxied by the Worker at this path as a design reference (noindex). */
export const FRAMER_REFERENCE_PATH = "/site";

/**
 * Links saved while the clone lived under /site (for example "/site/blog" in the CMS) point to
 * their root path now. Asset URLs such as "/site/logo.svg" are files and stay as they are.
 */
export function legacySitePath(href: string): string {
  if (href === "/site" || href === "/site/") return "/";
  const match = /^\/site(\/(?:blog|contact|solutions)(?:[/?#].*)?)$/.exec(href);
  if (match) return match[1];
  if (href.startsWith("/site#")) return href.slice("/site".length).replace(/^#/, "/#");
  return href;
}
